<!-- Navigation items -->
<ul
  class="list-none m-0 py-2 px-4 flex-1 overflow-visible max-mobile:overflow-y-auto max-mobile:overflow-x-hidden max-mobile:scrollbar-thin max-mobile:[scrollbar-color:rgba(255,255,255,0.2)_transparent]"
  role="list"
  [attr.aria-label]="'NAV.MAIN_NAV' | translate"
>
  @for (item of visibleNavItems(); track item.route) {
    <li class="group/item relative mt-0.5 mb-2.5 rounded-[28px]">
      <a
        class="group/link flex items-center justify-between gap-3 px-4 h-11.25 rounded-[10px] no-underline overflow-hidden whitespace-nowrap bg-[#82878D]/20 text-black transition-[background-color,color,gap,padding] duration-300 ease-in-out motion-reduce:transition-none hover:bg-[#32904A]/20 hover:text-[#256B36] [&.is-active]:bg-[#32904A]/20 [&.is-active]:text-[#256B36] focus-visible:outline focus-visible:outline-white/80 focus-visible:-outline-offset-2 group-[.is-collapsed]/nav:gap-0 group-[.is-collapsed]/nav:px-[--spacing(3.7)] max-mobile:gap-3! max-mobile:px-4!"
        [routerLink]="item.route"
        [class.is-active]="isActive(item)"
        [attr.aria-current]="isActive(item) ? 'page' : null"
        (click)="select(item)"
        [attr.aria-label]="item.label | translate"
      >
        <span
          class="h-6.25 w-6.25 flex-none bg-current mask-(--menu-icon) mask-contain mask-no-repeat mask-center [-webkit-mask-image:var(--menu-icon)] [-webkit-mask-size:contain] [-webkit-mask-repeat:no-repeat] [-webkit-mask-position:center] transition-[background-color] duration-300 ease-in-out motion-reduce:transition-none"
          [style.--menu-icon]="'url(' + item.icon + ')'"
          aria-hidden="true"
        ></span>
        <span
          class="flex-1 text-sm font-normal overflow-hidden text-ellipsis whitespace-nowrap max-w-50 opacity-100 transition-[max-width,opacity] duration-300 ease-in-out motion-reduce:transition-none group-[.is-collapsed]/nav:max-w-0 group-[.is-collapsed]/nav:opacity-0 max-mobile:max-w-50! max-mobile:opacity-100!"
          >{{ item.label | translate }}</span
        >
        <ng-icon
          name="heroChevronRight"
          aria-hidden="true"
          class="inline-flex overflow-hidden text-[18px] w-4.5 opacity-100 transition-[width,opacity] duration-300 ease-in-out motion-reduce:transition-none group-[.is-collapsed]/nav:w-0 group-[.is-collapsed]/nav:opacity-0 max-mobile:w-4.5! max-mobile:opacity-100!"
          [class.w-0]="collapsed()"
          [class.opacity-0]="collapsed()"
        />
      </a>
      <span
        class="pointer-events-none absolute left-21.75 top-1/2 -translate-y-1/2 z-100 bg-[#2e3129] text-[#eff2e9] py-1.5 px-3 rounded text-[13px] font-medium whitespace-nowrap opacity-0 transition-opacity duration-150 ease-[ease] motion-reduce:transition-none before:content-[''] before:absolute before:right-full before:top-1/2 before:-translate-y-1/2 before:border-[5px] before:border-transparent before:border-r-[#2e3129] before:z-100 max-mobile:hidden group-[.is-overlay-open]/nav:hidden group-[.is-collapsed]/nav:group-hover/item:opacity-100"
        aria-hidden="true"
        >{{ item.label | translate }}</span
      >
    </li>
  }
</ul>
